import { useQuery } from "react-query";
import { getFireAlarmSensorOptions } from "actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";

export const useGetFireAlarmSensorOptions = () => {
    const { data, isLoading, error } = useQuery(
        "GetFireAlarmSensorOptions",
        getFireAlarmSensorOptions,
        {
            refetchOnWindowFocus: false,
            onError: () => {
                toast.fire(
                    "Unexpected issue",
                    "Unable to load Fire Alarm Sensors number options right now. Please try again shortly.",
                    "error"
                );
            },
        }
    );

    return {
        data: error ? { data: [] } : data ?? { data: [] },
        isLoading
    };
};
